import { space4 } from 'glints-aries/es/@next/utilities/spacing';
import styled from 'styled-components';

export const MenuItemWithBadge = styled.span`
  display: flex;
  align-items: center;
  gap: ${space4};
`;
